import { Extension } from '@tiptap/core';

const onClassChange = (mutationList, observer) => {
  mutationList.forEach((mutation) => {
    if (mutation.attributeName === 'class') {
      if (mutation.target.classList.contains('resetRequest')) {
        observer._editor.chain().clearContent().run();
        mutation.target.classList.remove('resetRequest');
      }
    }
  });
};

const ClearContent = Extension.create({
  name: 'clearContent',

  onCreate({ editor }) {
    editor.storage._resetRequestObserver = new MutationObserver(onClassChange);
    editor.storage._resetRequestObserver._editor = editor;
    editor.storage._resetRequestObserver.observe(editor.view.dom, { attributes: true });
  },
});

export default [ClearContent];
